"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObjectType = void 0;
const isObjectType = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
exports.isObjectType = isObjectType;
//# sourceMappingURL=isObject.js.map